import { AccountLayout } from "../../layouts";
import { ForgotPasswordForm } from "../../components/ForgotPassword";

export const ForgotPasswordPage = () => {
  return <AccountLayout contents={<ForgotPasswordForm />} />;
};
